var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4762 9.16049H9.69927C9.10408 9.16049 8.62158 9.64299 8.62158 10.2382V21.0151C8.62158 21.6103 9.10408 22.0928 9.69927 22.0928H20.4762C21.0714 22.0928 21.5539 21.6103 21.5539 21.0151V10.2382C21.5539 9.64299 21.0714 9.16049 20.4762 9.16049ZM9.69927 7.54395C8.21129 7.54395 7.00504 8.7502 7.00504 10.2382V21.0151C7.00504 22.5031 8.21129 23.7093 9.69927 23.7093H20.4762C21.9642 23.7093 23.1704 22.5031 23.1704 21.0151V10.2382C23.1704 8.7502 21.9642 7.54395 20.4762 7.54395H9.69927Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.505 10.5073C28.505 10.0907 28.1673 9.75296 27.7506 9.75296C27.334 9.75296 26.9962 10.0907 26.9962 10.5073C26.9962 10.924 27.334 11.2617 27.7506 11.2617C28.1673 11.2617 28.505 10.924 28.505 10.5073ZM29.6366 10.5073C29.6366 9.46576 28.7922 8.62138 27.7506 8.62138C26.709 8.62138 25.8647 9.46576 25.8647 10.5073C25.8647 11.5489 26.709 12.3933 27.7506 12.3933C28.7922 12.3933 29.6366 11.5489 29.6366 10.5073Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.505 16.9737C28.505 16.557 28.1673 16.2193 27.7506 16.2193C27.334 16.2193 26.9962 16.557 26.9962 16.9737C26.9962 17.3903 27.334 17.728 27.7506 17.728C28.1673 17.728 28.505 17.3903 28.505 16.9737ZM29.6366 16.9737C29.6366 15.9321 28.7922 15.0877 27.7506 15.0877C26.709 15.0877 25.8647 15.9321 25.8647 16.9737C25.8647 18.0152 26.709 18.8596 27.7506 18.8596C28.7922 18.8596 29.6366 18.0152 29.6366 16.9737Z",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.505 22.3621C28.505 21.9454 28.1673 21.6077 27.7506 21.6077C27.334 21.6077 26.9962 21.9454 26.9962 22.3621C26.9962 22.7787 27.334 23.1165 27.7506 23.1165C28.1673 23.1165 28.505 22.7787 28.505 22.3621ZM29.6366 22.3621C29.6366 21.3205 28.7922 20.4761 27.7506 20.4761C26.709 20.4761 25.8647 21.3205 25.8647 22.3621C25.8647 23.4037 26.709 24.248 27.7506 24.248C28.7922 24.248 29.6366 23.4037 29.6366 22.3621Z",
    fill: "#323232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13156 21.2844C1.13156 21.701 1.46931 22.0388 1.88595 22.0388C2.30258 22.0388 2.64033 21.701 2.64033 21.2844C2.64033 20.8678 2.30258 20.53 1.88595 20.53C1.46931 20.53 1.13156 20.8678 1.13156 21.2844ZM-1.59516e-05 21.2844C-1.59391e-05 22.326 0.844359 23.1704 1.88595 23.1704C2.92754 23.1704 3.77191 22.326 3.77191 21.2844C3.77191 20.2428 2.92754 19.3984 1.88595 19.3984C0.844359 19.3984 -1.5964e-05 20.2428 -1.59516e-05 21.2844Z",
    fill: "#323232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13156 14.8183C1.13156 15.235 1.46931 15.5727 1.88595 15.5727C2.30258 15.5727 2.64033 15.235 2.64033 14.8183C2.64033 14.4017 2.30258 14.064 1.88595 14.064C1.46931 14.064 1.13156 14.4017 1.13156 14.8183ZM-1.59516e-05 14.8183C-1.59391e-05 15.8599 0.844359 16.7043 1.88595 16.7043C2.92754 16.7043 3.77191 15.8599 3.77191 14.8183C3.77191 13.7767 2.92754 12.9324 1.88595 12.9324C0.844359 12.9324 -1.5964e-05 13.7767 -1.59516e-05 14.8183Z",
    fill: "#323232"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13156 9.42991C1.13156 9.84654 1.46931 10.1843 1.88595 10.1843C2.30258 10.1843 2.64033 9.84654 2.64033 9.42991C2.64033 9.01327 2.30258 8.67552 1.88595 8.67552C1.46931 8.67552 1.13156 9.01327 1.13156 9.42991ZM-1.59516e-05 9.42991C-1.59391e-05 10.4715 0.844359 11.3159 1.88595 11.3159C2.92754 11.3159 3.77191 10.4715 3.77191 9.42991C3.77191 8.38832 2.92754 7.54395 1.88595 7.54395C0.844359 7.54395 -1.5964e-05 8.38832 -1.59516e-05 9.42991Z",
    fill: "#323232"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64538 1.88601C9.64538 1.46937 9.30763 1.13162 8.891 1.13162C8.47436 1.13162 8.13661 1.46937 8.13661 1.88601C8.13661 2.30264 8.47436 2.64039 8.891 2.64039C9.30763 2.64039 9.64538 2.30264 9.64538 1.88601ZM10.777 1.88601C10.777 0.84442 9.93259 4.50262e-05 8.891 4.50386e-05C7.84941 4.5051e-05 7.00504 0.84442 7.00504 1.88601C7.00504 2.9276 7.84941 3.77197 8.891 3.77197C9.93259 3.77197 10.777 2.9276 10.777 1.88601Z",
    fill: "#323232"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 1.88601C21.5 1.46937 21.1622 1.13162 20.7456 1.13162C20.329 1.13162 19.9912 1.46937 19.9912 1.88601C19.9912 2.30264 20.329 2.64039 20.7456 2.64039C21.1622 2.64039 21.5 2.30264 21.5 1.88601ZM22.6316 1.88601C22.6316 0.84442 21.7872 4.50262e-05 20.7456 4.50386e-05C19.704 4.5051e-05 18.8596 0.84442 18.8596 1.88601C18.8596 2.9276 19.704 3.77197 20.7456 3.77197C21.7872 3.77197 22.6316 2.9276 22.6316 1.88601Z",
    fill: "#323232"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0338 1.88601C15.0338 1.46937 14.6961 1.13162 14.2795 1.13162C13.8628 1.13162 13.5251 1.46937 13.5251 1.88601C13.5251 2.30264 13.8628 2.64039 14.2795 2.64039C14.6961 2.64039 15.0338 2.30264 15.0338 1.88601ZM16.1654 1.88601C16.1654 0.84442 15.321 4.50262e-05 14.2795 4.50386e-05C13.2379 4.5051e-05 12.3935 0.84442 12.3935 1.88601C12.3935 2.9276 13.2379 3.77197 14.2795 3.77197C15.321 3.77197 16.1654 2.9276 16.1654 1.88601Z",
    fill: "#323232"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5301 29.114C20.5301 29.5306 20.8678 29.8684 21.2845 29.8684C21.7011 29.8684 22.0389 29.5306 22.0389 29.114C22.0389 28.6974 21.7011 28.3596 21.2845 28.3596C20.8678 28.3596 20.5301 28.6974 20.5301 29.114ZM19.3985 29.114C19.3985 30.1556 20.2429 31 21.2845 31C22.3261 31 23.1704 30.1556 23.1704 29.114C23.1704 28.0724 22.3261 27.228 21.2845 27.228C20.2429 27.228 19.3985 28.0724 19.3985 29.114Z",
    fill: "#323232"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67548 29.114C8.67548 29.5306 9.01323 29.8684 9.42986 29.8684C9.8465 29.8684 10.1842 29.5306 10.1842 29.114C10.1842 28.6974 9.8465 28.3596 9.42986 28.3596C9.01323 28.3596 8.67548 28.6974 8.67548 29.114ZM7.5439 29.114C7.5439 30.1556 8.38827 31 9.42986 31C10.4715 31 11.3158 30.1556 11.3158 29.114C11.3158 28.0724 10.4715 27.228 9.42986 27.228C8.38827 27.228 7.5439 28.0724 7.5439 29.114Z",
    fill: "#323232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1416 29.114C15.1416 29.5306 15.4794 29.8684 15.896 29.8684C16.3126 29.8684 16.6504 29.5306 16.6504 29.114C16.6504 28.6974 16.3126 28.3596 15.896 28.3596C15.4794 28.3596 15.1416 28.6974 15.1416 29.114ZM14.01 29.114C14.01 30.1556 14.8544 31 15.896 31C16.9376 31 17.782 30.1556 17.782 29.114C17.782 28.0724 16.9376 27.228 15.896 27.228C14.8544 27.228 14.01 28.0724 14.01 29.114Z",
    fill: "#323232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0827 3.50269H9.69924V5.5927L11.8873 7.78077L10.7442 8.92384L8.0827 6.26229V3.50269Z",
    fill: "#323232"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7406 3.50269H15.3571V5.5927L17.5452 7.78077L16.4021 8.92384L13.7406 6.26229V3.50269Z",
    fill: "#323232"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5539 3.50269H19.9373V5.5927L17.7492 7.78077L18.8923 8.92384L21.5539 6.26229V3.50269Z",
    fill: "#323232"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3621 28.02H20.7456V25.93L18.5575 23.7419L19.7006 22.5989L22.3621 25.2604V28.02Z",
    fill: "#323232"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7043 28.02H15.0877V25.93L12.8997 23.7419L14.0427 22.5989L16.7043 25.2604V28.02Z",
    fill: "#323232"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89093 28.02H10.5075V25.93L12.6955 23.7419L11.5525 22.5989L8.89093 25.2604V28.02Z",
    fill: "#323232"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9424 23.4397L26.9424 21.8232L24.8523 21.8232L22.6643 19.6351L21.5212 20.7782L24.1827 23.4397L26.9424 23.4397Z",
    fill: "#323232"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23312 8.89111L3.23312 10.5077L5.32314 10.5077L7.51121 12.6957L8.65428 11.5527L5.99273 8.89111L3.23312 8.89111Z",
    fill: "#323232"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9424 9.96851L26.9424 11.585L24.8523 11.585L22.6643 13.7731L21.5212 12.6301L24.1827 9.96851L26.9424 9.96851Z",
    fill: "#323232"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23312 22.3623L3.23312 20.7458L5.32314 20.7458L7.51121 18.5577L8.65428 19.7008L5.99273 22.3623L3.23312 22.3623Z",
    fill: "#323232"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9424 17.782L26.9424 16.1654L24.8523 16.1654L22.6643 13.9774L21.5212 15.1204L24.1827 17.782L26.9424 17.782Z",
    fill: "#323232"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23312 14.0098L3.23312 15.6263L5.32314 15.6263L7.51121 17.8144L8.65428 16.6713L5.99273 14.0098L3.23312 14.0098Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiNavIcon);
export default __webpack_public_path__ + "static/media/aiNavIcon.6d333be24d86c02dd04c010823391f2e.svg";
export { ForwardRef as ReactComponent };